import React from 'react';

const ProductNoteHtml = ({ htmlContent }) => {
    if (!htmlContent) return null;
 
    
    // Check if the content contains an anchor tag
    const hasAnchorTag = htmlContent.includes('<a');
    
    if (!hasAnchorTag) {
        // If no anchor tag, render the HTML content directly
        return (
            <div 
                className='productNote'
                dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
        );
    }
    
    // For content with anchor tags, we need to handle it more carefully
    // Check if the content is wrapped in paragraph tags
    const isWrappedInParagraph = htmlContent.trim().startsWith('<p>') && htmlContent.trim().endsWith('</p>');
    
    if (isWrappedInParagraph) {
        // If wrapped in paragraph tags, render the HTML directly
        return (
            <div 
                className='productNote'
                dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
        );
    }
    
    // For content with anchor tags but no paragraph wrapper, 
    // we need to process the HTML to style the links properly
    const processHtmlWithLinks = (html) => {
        // Replace anchor tags with styled versions
        return html.replace(
            /<a\s+href="([^"]+)"[^>]*>(.*?)<\/a>/g,
            '<a href="$1" target="_blank" rel="noopener noreferrer" style="color: #007DAB; text-decoration: underline;">$2</a>'
        );
    };
    
    const processedHtml = processHtmlWithLinks(htmlContent);
    
    return (
        <div 
            className='productNote'
            dangerouslySetInnerHTML={{ __html: processedHtml }}
        />
    );
};

export default ProductNoteHtml; 